
import { Component, Inject, Vue } from 'vue-property-decorator';
import GeneralScaffold from '@/components/GeneralScaffold.vue';
import FormModelDisplay from '@/components/FormModelDisplay.vue';
import FrontPageContentRepository from '@/repositories/content/FrontPageContentRepository';

@Component({
    components: {
        GeneralScaffold,
        FormModelDisplay,
    },
})
export default class FrontPageContentFormScreen extends Vue {
    @Inject()
    public readonly frontPageContentRepository!: FrontPageContentRepository;
}
